import { map, tap,filter } from "rxjs/operators";
import { Injectable,EventEmitter } from "@angular/core";
import { Observable, of } from "rxjs";
import {
  BookingsTabControls,
  CalendarTabControls,
  Controls,
  FindASpaceTabControls,
  MeetingsTabControls,
  PreferenceDetails,
  PreferencesControlsConfig,
  ServiceOrdersTabControls,
  LocalStorageKey,
  PreferenceBody,
  AllViewItem,
  ViewDetail,
  TAB_NAME_ADAPTER,
  FIELD_PROPERTY_ADAPTER,
  PreferencesSubTabFieldDTO,
  PreferencesTabConfigDTO,
  PreferencesViewData,
  PreferencesTabFieldDTO,
  PreferencesBookingsData,
  PreferencesCalendarData,
  PreferencesFindASpaceData,
  PreferencesMeetingsData,
  PreferencesServiceOrdersData,
  SelectOption,
  ALL_SELECTED,MASTER_VIEW_ID,
} from "../../../models/preferences.model";
import { DataContextService } from "../../datacontext.service";
import { BehaviorSubject } from "rxjs";
import { SelectedGroupMultiselectItem } from "src/app/shared/components/group-multiselect-dropdown/group-multiselect-dropdown.component";
import { Building, ServiceOrderType } from "src/app/models/masterdata.model";
import { MultiSelectItem } from "src/app/shared/components/multi-select/multi-select.component";



@Injectable()
export class PreferencesService {
  config: PreferencesControlsConfig;
  private favoriteView$ = new BehaviorSubject<PreferenceDetails>(null);
  private selectedView$ = new BehaviorSubject<PreferenceDetails>(null);
  public languageChanged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isAttemptToSave: boolean;
  
  private static hideDropDownsEve: EventEmitter<boolean> = new EventEmitter();
  static getHideDropDownTriggerEvent() {
    return this.hideDropDownsEve;
  }
  static hideDropDownTriggerEvent(isHide: boolean) {
    this.hideDropDownsEve.emit(isHide);
  }
  constructor(private hotelingService: DataContextService) {
    this.getConfig().subscribe();
  }

  getConfig(): Observable<PreferencesControlsConfig> {
    if (this.config) return of(this.config);
    return this.hotelingService.getData<{ data: PreferencesTabConfigDTO[] }>('Views/tabs').pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return this.hotelingService.showErrorToaster(response);
        }
      }),
      map((config: PreferencesTabConfigDTO[]) => {
        return this.setupConfig(config);
      }),
      tap((config: PreferencesControlsConfig) =>{
        this.config = config
      })
    );
  }

  private setupConfig(config: PreferencesTabConfigDTO[]): PreferencesControlsConfig {
    const result = {};

    config.forEach((tab: PreferencesTabConfigDTO) => {
      result[TAB_NAME_ADAPTER[tab.name]] = {};

      result[TAB_NAME_ADAPTER[tab.name]] = tab.tabFields.reduce(
        (prev, curr: PreferencesTabFieldDTO) => ({ ...prev, ...{ [FIELD_PROPERTY_ADAPTER[tab.name][curr.name]]: curr.id } }),
        {}
      );

      tab.subTabs.forEach((subTab: PreferencesSubTabFieldDTO) => {
        result[TAB_NAME_ADAPTER[tab.name]] = {
          ...result[TAB_NAME_ADAPTER[tab.name]],
          ...subTab.tabFields.reduce(
            (prev, curr: PreferencesTabFieldDTO) => ({
              ...prev,
              ...{ [FIELD_PROPERTY_ADAPTER[tab.name][subTab.name][curr.name]]: curr.id },
            }),
            {}
          ),
        };
      });
    });

    return result;
  }

  getPathById(id: number): { tab: string; control: string } {
    for (const tab in this.config) {
      for (const control in this.config[tab]) {
        if (this.config[tab][control] === id) {
          return { tab, control };
        }
      }
    }
  }

  parseViewDetails(data: PreferenceDetails): PreferencesViewData {
    const tabs: PreferencesControlsConfig = {
      findASpaceTab: {},
      calendarTab: {},
      meetingsTab: {},
      bookingsTab: {},
      serviceOrdersTab: {},
    };
    data.viewDetails.map((field) => {

      const path = this.getPathById(field.tabFieldId);
      if (path) {
        if (
          path.control === FindASpaceTabControls.Capacity ||
          path.control === CalendarTabControls.Capacity ||
          (path.tab === Controls.FindASpaceTab && path.control === FindASpaceTabControls.Type) ||
          (path.tab === Controls.FindASpaceTab && path.control === FindASpaceTabControls.Category)
        ) {
          tabs[path.tab][path.control] = field.value;
        } else if (
          path.control === ServiceOrdersTabControls.InOfficeIncludeDelete ||
          path.control === ServiceOrdersTabControls.VirtualIncludeDelete
        ) {
          tabs[path.tab][path.control] = Boolean(Number(field.value));
        } else {
          if (field.tabFieldId == 1 || field.tabFieldId == 4) {
            tabs[path.tab][path.control] = this.convertValue(field.value);
          }
          else if (field.tabFieldId == 19 || field.tabFieldId == 21) {
            var SOData: ServiceOrderType[] = [];
            SOData = field.value.split(',').map(i => {
              const SO = DataContextService.ServiceOrderTypes.find(s => s.id === Number(i))
              if (SO) {
                return SO
              }
            }).filter(Boolean);
            if(SOData.length<0)
            tabs[path.tab][path.control] = this.setUpServiceOrderData(SOData);
          }
          else{
            tabs[path.tab][path.control] = this.convertValue(field.value);

          }
        }
      }
    });

    const findASpaceTab = new PreferencesFindASpaceData(


      tabs.findASpaceTab.spaceFeatures ,
      tabs.findASpaceTab.capacity,
      tabs.findASpaceTab.type
    );

    const calendarTab = new PreferencesCalendarData(tabs.calendarTab.roomType, tabs.calendarTab.spaceFeatures, tabs.calendarTab.capacity);

    const meetingTab = new PreferencesMeetingsData(
      tabs.meetingsTab.dashboardRequestType,
      tabs.meetingsTab.dashboardMeetingType,
      tabs.meetingsTab.dashboardStatus,
      tabs.meetingsTab.meetingRequestType,
      tabs.meetingsTab.meetingStatus,
      tabs.meetingsTab.virtualMeetingStatus,
      tabs.meetingsTab.unfulfilledSpaceType
    );

    const allBookingsTab = new PreferencesBookingsData(
      tabs.bookingsTab.serviceOrders,
      tabs.bookingsTab.spaceType,
      tabs.bookingsTab.meetingType,
      tabs.bookingsTab.dashboardStatus,
      tabs.bookingsTab.waitListStatus
    );

    const serviceOrderTab = new PreferencesServiceOrdersData(
      tabs.serviceOrdersTab.type,
      tabs.serviceOrdersTab.serviceOrder,
      tabs.serviceOrdersTab.status,
      tabs.serviceOrdersTab.virtualServiceOrders,
      tabs.serviceOrdersTab.virtualStatus,
      tabs.serviceOrdersTab.inOfficeIncludeDelete,
      tabs.serviceOrdersTab.virtualIncludeDelete
    );

    return new PreferencesViewData(
      data.id,
      data.name,
      data.isFavourite,
      data.isActive,
      // data.countries.split(',').map((id) => Number(id)),
      this.convertValueToOptions(data.buildings),
      this.floorInitialValue(data.buildings,data.floors),
      data.assignedToMe,
      data.recordsPerPage,
      data.revision,
      findASpaceTab,
      calendarTab,
      meetingTab,
      allBookingsTab,
      serviceOrderTab,
      data.allViews
    );
  }

  setUpServiceOrderData(dataArray:ServiceOrderType[]):SelectedGroupMultiselectItem[]  {

    const data = {
      ['TaskType']: {
        id:0,
        groupItems: [],
      },
      ['catering']: {
        id:1,
        groupItems: [],
      },
    };
    dataArray.forEach((order: ServiceOrderType) => {
      switch (order.serviceOrderCategory) {
        case 'TaskType': {
          data['TaskType'].groupItems.push(
            order.id
          );
          data['TaskType'].groupItems.sort((a, b) => (a.name == b.name ? 0 : a.name > b.name ? 1 : -1));
          break;
        }
        case 'catering': {
          data['catering'].groupItems.push(
            order.id
          );
          break;
        }
      }
    });
    return [data['TaskType'], data['catering']];

  }

  convertValue(value:string):(Number|string)[]{
    return value.split(',').map((id) => isNaN(Number(id)) ? id : Number(id));
  }

  private convertValueToOptions(value: string): SelectOption[] {
    if (!value) {
      return [];
    }

    if (value === 'All') {
      return ALL_SELECTED;
    }

    return value.split(',').map((id) => ({
      value: isNaN(Number(id)) ? id : Number(id),
      name: '',
    }));
  }
  private floorInitialValue(building,floor): SelectedGroupMultiselectItem[]{
    var location: SelectedGroupMultiselectItem[] = []
    if (building) {
      const buildings: number[] = building.split(',').map((id) => (
        Number(id)
      ));
      const floors: number[] = floor === 'All' ?
        DataContextService.Buildings.find(i => i.id === buildings[0]).floors.map(i => i.uniqueKey) :
        floor.split(',').map((id) => (
          Number(id)
        ));
      buildings.forEach(element => {
        let floorUniqueKeys = [];
        const building = DataContextService.Buildings.find(d => d.id === element);
        if (building) {
          floors.forEach(d => {
            if (building.floors.find(u => u.uniqueKey === d))
              floorUniqueKeys.push(d);
          })
        }
        location.push({
          id: element,
          groupItems: floorUniqueKeys
        })
      });
    }
    return location

  }

  getPreferenceViewData(id: string): Observable<PreferencesViewData> {
    return this.hotelingService.getData<{ data: PreferenceDetails }>(`Views/${id}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return this.parseViewDetails(this.hotelingService.removeInactiveBuildingFloors(response.data));
        } else {
          return this.hotelingService.showErrorToaster(response);
        }
      })
    );
  }

  createView(body: PreferenceBody): Observable<AllViewItem> {
    return this.hotelingService.postData('Views', body).pipe(
      map((res) => {
        if (res.status == 200) {
          return res.data;
        } else {
          return this.hotelingService.showErrorToaster(res);
        }
      })
    );
  }

  getFavoriteView(): Observable<PreferenceDetails> {
    return this.hotelingService.getData('Views/favourite').pipe(
      map((response: { data: PreferenceDetails }) => {
        const data = response.data;
        const convertedAllViews: AllViewItem[] =
          data.allViews && data.allViews.length > 0
            ? data.allViews.map((allViewItemDTO) => {
              return {
                id: allViewItemDTO.id,
                name: allViewItemDTO.name,
                isActive: allViewItemDTO.isActive,
                isFavourite: allViewItemDTO.isFavourite,
              };
            })
            : [{
              id: data.id,
              name: data.name,
              isActive: data.isActive,
              isFavourite: data.isFavourite
            }];

        const viewDetailDTO = new Array<ViewDetail>();
        data.viewDetails.map((field) => {
          viewDetailDTO.push(field);
        });

        const favoriteView: PreferenceDetails = {
          allViews: convertedAllViews,
          assignedToMe: data.assignedToMe,
          buildings: data.buildings != null ? data.buildings : "",
          // countries: data.countries,
          floors: data.floors,
          id: data.id,
          isActive: data.isActive,
          isFavourite: data.isFavourite,
          name: data.name,
          recordsPerPage: data.recordsPerPage,
          revision: data.revision,
          viewDetails: viewDetailDTO,
        };

        return favoriteView;
      })
    );
  }

  updateView(body: PreferenceBody): Observable<any> {
    return this.hotelingService.patchData('Views', body, true).pipe(
      map((res) => {
        if (res.status == 200) {
          return res;
        } else {
          return this.hotelingService.showErrorToaster(res);
        }
      })
    );
  }

  deleteView(id: string): Observable<{}> {
    return this.hotelingService.deleteData(`Views/${id}`).pipe(
      map((res) => {
        if (res.status == 200) {
          return res;
        } else {
          return this.hotelingService.showErrorToaster(res);
        }
      })
    );
  }
  getView(id: string): Observable<PreferenceDetails> | Observable<any> {
    return this.hotelingService.getData(`Views/${id}`).pipe(map((res: any) => {
      if (res.status == 200) {
        return res.data as PreferenceDetails;
      }
      if (res.status == 404) {
        return res.data = [];
      }
    }));
  }

  get allViews$(): Observable<AllViewItem[]> {
    return this.favoriteView$.pipe(
      filter(data => !!data),
      map((data) => {
        if (data.allViews.length) {
          return data.allViews
            .sort((a, b) => Number(b.isActive) - Number(a.isActive))
            .sort((a, b) => Number(b.isFavourite) - Number(a.isFavourite));
        } else {
          return [
            {
              isFavourite: data.isFavourite,
              id: data.id,
              isActive: data.isActive,
              name: data.name,
            },
          ];
        }
      })
    );
  }

  //FavoriteView Service Region Start

  get allFavoriteViewData$(): Observable<PreferenceDetails> {
    return this.favoriteView$;
  }
  setViewToLocalStorage(view: PreferenceDetails) {
    localStorage.setItem(LocalStorageKey.SelectedView, JSON.stringify(view));
    this.selectedView$.next(view);
  }
  setFavoriteViewInLocalStorage(view: PreferenceDetails) {
    this.setFavoriteViewToStorage(view);
  }
  private setFavoriteViewToStorage(favoriteView: PreferenceDetails): void {
    localStorage.setItem(LocalStorageKey.FavoriteView, JSON.stringify(favoriteView));
    this.favoriteView$.next(favoriteView);
  }

  getLatestViewData$(): Observable<PreferenceDetails> {
    return this.getFavoriteView().pipe(
      tap((data) => {
        const favoriteView = data;
        if (favoriteView.id === MASTER_VIEW_ID && !favoriteView.allViews.length) {
          favoriteView.allViews.push({
            id: favoriteView.id,
            isActive: favoriteView.isActive,
            isFavourite: favoriteView.isFavourite,
            name: favoriteView.name,
          });
        }

        this.setFavoriteViewToStorage(favoriteView);
      })
    );
  }
  getMasterViewData$(): Observable<PreferencesViewData> {
    return this.favoriteView$.pipe(map((data) => this.parseViewDetails(data)));
  }
  set selectedView(view: PreferenceDetails) {
    this.selectedView$.next(view);
  }



  getLanguages() {
    const url = `Language/Supported`;
    return this.hotelingService.getData<any>(url);
  }

  savePreferredLanguage(data: any) {
    const url = `Language/Preference`;

    return this.hotelingService.postData(url, data, true);
  }
  
  //Language Service End

  // getViews(){
  //   let viewData = this.getViewFromLocalStorage();
  //               if (this.checkForInactiveBuildingFloors(viewData)) {
  //                   this.route.navigate([`${RoutesConfig.pages.preferences}`], {
  //                       queryParams: {
  //                           viewId: viewData.id
  //                       }
  //                   });
  //               } else {
  //                   // this._router.navigate([this.dataContextService.BreadcrumbNavigation || BreadcrumbNavigation.get(Breadcrumb.ReservationWizardDetails)]);
  //               }
  // }

  //   checkForInactiveBuildingFloors(viewData: PreferenceDetails): boolean {
  //     let view = this.hotelingService.removeInactiveBuildingFloors(viewData);
  //     this.storeViewIntoLocalStorage(view);
  //     this.favoriteViewData = view;
  //     if (view.buildings == null || view.floors== null)
  //         return true;
  //     else       
  //         return false;
  // }

  //   getViewFromLocalStorage(): PreferenceDetails{
  //     let viewId = this.hotelingService.fetchFromLocalStorage('selectedViewId');
  //     if (viewId) {
  //         return JSON.parse(this.hotelingService.fetchFromLocalStorage(LocalStorageKey.SelectedView)) as PreferenceDetails;
  //     }
  //     else {
  //         return JSON.parse(this.hotelingService.fetchFromLocalStorage(LocalStorageKey.FavoriteView)) as PreferenceDetails;
  //     }
  // }
  // storeViewIntoLocalStorage(view: PreferenceDetails) {
  //     let viewId = this.hotelingService.fetchFromLocalStorage('selectedViewId');
  //     if (viewId) {
  //         this.hotelingService.storeInLocalStorage(LocalStorageKey.SelectedView, JSON.stringify(view));                    
  //     }
  //     else {
  //         this.hotelingService.storeInLocalStorage(LocalStorageKey.FavoriteView, JSON.stringify(view));
  //     }
  // }
}

